import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import { Tax } from '../models/tax';

export class TaxService extends BaseService<Tax> {
  override model = Tax;
  override modelName = 'tax';
  override modelLabel = 'Tax';

  /**
   * Apply this tax across all services / products / passes. Backend route is
   * `POST /tax/{id}/bulkSet` — the id is a path param, not a body field. Pass
   * `type` as e.g. `'services'`, `'products'`, `'passes'` and `state` flips
   * it on/off across that target.
   */
  async bulkSet(
    tax: Tax,
    type: string,
    state: boolean,
  ): Promise<boolean> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/${tax.idTax}/bulkSet`,
      data: {
        [type]: state ? 'on' : 'off',
      },
    });

    const response = await this.request(request);
    return response.success;
  }
}
